<div class="w-full flex items-center gap-2 pr-5">
  <mat-icon *ngIf="addAlertIcon" class="mdi mdi-alert text-base leading-4 color-custom-red"></mat-icon>
  <form class="w-full autocomplete-component">
    <input type="text" class="w-full border-none autocomplete-input-comp"
      [placeholder]="placeholder"
      [formControl]="control"
      [matAutocomplete]="auto"
      (blur)="onInputBlur()"
      (keypress)="onlyAcceptNumber ? filterKeyNumber($event) : null"
      #autoInput
    >
    <mat-autocomplete #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)"
    [displayWith]="displayFn.bind(this)"
    >
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ getDisplayValue(option) }}
      </mat-option>
    </mat-autocomplete>
  </form>
  <div class="-mr-5 flex items-center bg-white">
    <ng-container *ngIf="!control.value; else clearInput">
      <mat-icon *ngIf="addChevronDownIcon"
        (click)="openAutocomplete()"
        mat-raised-button
        class="mdi mdi-chevron-down text-gray-600 text-lg leading-[18px]">
      </mat-icon>
    </ng-container>
    <ng-template #clearInput>
      <ion-icon (click)="onClearInput()" name="close-outline" class="text-xl leading-[20px] cursor-pointer"></ion-icon>
    </ng-template>
  </div>
</div>
